import { Vector3 } from "three";
import { easeInOutQuart } from "../common";
export class CenterAnimation {
  constructor(geometry, options) {
    var _a;
    Object.defineProperty(this, "duration", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "elapsedTime", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "geometry", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "initialCenter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "translationOffset", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "resolveAnimation", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "activeStatus", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "completed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "canceledStatus", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "tags", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    this.duration = (_a = options.duration) !== null && _a !== void 0 ? _a : 2;
    this.geometry = geometry;
    const initialCenter = options.initialBounds.getCenter(new Vector3());
    const targetCenter = options.targetBounds.getCenter(new Vector3());
    this.translationOffset = new Vector3(initialCenter.x - targetCenter.x, initialCenter.y - targetCenter.y, initialCenter.z - targetCenter.z);
    this.initialCenter = geometry.position.clone();
  }
  get isComplete() {
    return this.completed;
  }
  get isCanceled() {
    return this.canceledStatus;
  }
  resetMeshState() {
    this.activeStatus = false;
    this.interpolateValues(this.duration);
    this.resolveAnimation && this.resolveAnimation();
  }
  cancel() {
    this.activeStatus = false;
    this.canceledStatus = true;
    this.resetMeshState();
    if (this.resolveAnimation) {
      this.resolveAnimation();
    }
  }
  get isActive() {
    return this.activeStatus;
  }
  update(delta) {
    if (this.isActive && this.elapsedTime < this.duration) {
      this.interpolateValues(this.elapsedTime);
      this.elapsedTime += delta;
    }
    if (this.elapsedTime >= this.duration && this.isActive) {
      this.interpolateValues(this.duration);
      this.resolveAnimation && this.resolveAnimation();
      this.activeStatus = false;
    }
  }
  start() {
    this.activeStatus = true;
    return new Promise(resolve => {
      this.resolveAnimation = resolve;
    });
  }
  resume() {
    if (this.resolveAnimation !== undefined) {
      this.activeStatus = true;
    }
  }
  stop() {
    this.activeStatus = false;
  }
  interpolateValues(time) {
    this.geometry.position.x = easeInOutQuart(time, this.initialCenter.x, this.translationOffset.x, this.duration);
    this.geometry.position.y = easeInOutQuart(time, this.initialCenter.y, this.translationOffset.y, this.duration);
    this.geometry.position.z = easeInOutQuart(time, this.initialCenter.z, this.translationOffset.z, this.duration);
  }
}